import { initializeActivity } from "../actions/playerActions";
import { normalizeActivity } from "../utils/utils";
import ambifi from "../ambifi";

export async function setActivities(tree, activities) {
	// Need to loop through and normalize each one
	if (activities.length > 1) {
		for (let i = 1; i < activities.length; i++) {
			const activity = activities[i];

			await initializeActivity(tree, ambifi.persistenceManager.restoreActivityResponsesAndState(normalizeActivity(activity)), null, false, false); //eslint-disable-line
			activities[i] = tree.get(["activity"]);//eslint-disable-line
		}

		await initializeActivity(tree, ambifi.persistenceManager.restoreActivityResponsesAndState(normalizeActivity(activities[0])), null, false, true); //eslint-disable-line
		activities[0] = tree.get(["activity"]);//eslint-disable-line

		tree.set(["activities"], activities);
	} else {
		await initializeActivity(tree, ambifi.persistenceManager.restoreActivityResponsesAndState(normalizeActivity(activities[0])), null, false, true);

		tree.set(["activities"], activities);
	}
}